// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Pl-z","title":"Ql-z","nav":"Rl-z","flexCell":"Sl-z","facetLink":"Tl-z"};